import { http } from "src/axios";
import type { ServerCustomerAccessCheckResponse } from "./types/server-customer-access";

export async function getCustomerAccessCheckResults({
  signal,
}: {
  signal: AbortSignal;
}): Promise<ServerCustomerAccessCheckResponse> {
  const response = await http.get<ServerCustomerAccessCheckResponse>(`/api/v2/customers/access`, { signal });
  return response.data;
}
